import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import {
  flexSpace,
  borderBottom,
  SPACE_COMPACT,
  flexStart,
  flexOne,
  textOverflowHidden,
  SPACE_MINIMUM,
} from '@/styles';

export const actions = [
  css`
    display: flex;
    gap: 0 ${SPACE_COMPACT}px;
    align-items: center;
  `,
];

export const layout = [
  flexSpace,
  borderBottom,
  css`
    background-color: ${token('elevation.surface.sunken', '#f7f8f9')};
    flex-flow: nowrap;
    align-items: center;
    border-radius: ${SPACE_MINIMUM}px ${SPACE_MINIMUM}px 0 0;
  `,
];

export const layoutGroup = css`
  background-color: ${token('color.background.accent.blue.subtlest')};
`;

export const layoutMimir = css`
  border-bottom: 1px solid ${token('color.border.accent.orange')};
  background-color: ${token('color.background.accent.orange.subtlest')};
`;

export const content = [
  flexStart,
  flexOne,
  textOverflowHidden,
  css`
    /* We want to have a 8px 14px balanced looking visual padding for the header */
    padding: ${SPACE_COMPACT}px ${SPACE_COMPACT + SPACE_COMPACT / 2}px;
    flex-wrap: nowrap;
    line-height: 1;
    & > * {
      margin-right: ${SPACE_COMPACT}px;
    }
  `,
];

export const titleQualityIssueIconStyles = css`
  margin-left: -4px;
`;
